
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13129',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13129",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.491",
  "data-fetching-client": "static-1.9908",
  "foundations-components": "static-1.8394",
  "foundations-components-legacy": "static-1.1419",
  "foundations-theming": "static-1.4708",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.86",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8278",
  "hub-http-shared-msw-handlers": "static-1.10534",
  "hubspot-dlb": "static-2.1882",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11734",
  "I18n": "static-7.1663",
  "jasmine-runner": "static-1.6700",
  "marketplace-discovery-studio-lib": "static-1.556",
  "marketplace-storefront-base": "static-1.13192",
  "quartz": "static-1.7372",
  "react-dlb": "static-1.85",
  "react-rhumb": "static-1.16961",
  "reactive-variable-buffer-atom": "static-1.3106",
  "reporting-testing-lib": "static-1.10537",
  "reselect": "static-3.9",
  "settings-ui-lib": "static-1.12772",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7563",
  "ui-addon-i18n": "static-1.11396",
  "ui-addon-react-router-dom": "static-1.9788",
  "unified-auth": "static-1.813",
  "unified-auth-core-lib": "static-1.1095",
  "usage-tracker": "static-1.7607",
  "usage-tracker-core": "static-1.7457",
  "customer-data-property-utils": "static-1.8350",
  "hub-http": "static-1.6465",
  "integrations-lib": "static-1.16934",
  "marketplace-ui-common": "static-1.20612",
  "marketplace-ui-install": "static-1.598",
  "property-management-iframe": "static-1.14001",
  "quartz-config": "static-1.1150",
  "quartz-core": "static-1.6591",
  "quartz-routing": "static-1.802",
  "quick-fetch": "static-1.4097",
  "react": "static-7.191",
  "rpc-client-utils": "static-1.4914",
  "ts-schema": "static-1.4259",
  "ui-universal-auth": "static-1.9299",
  "UIComponents": "static-3.8680",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9867",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3582",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3649",
  "quartz-webpack": "static-1.3596",
  "bend-plugin-quartz-routing": "static-1.450",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4663",
  "floating-ui": "static-1.62",
  "foundations-assets": "static-1.5129",
  "foundations-theming-specialty": "static-1.2424",
  "framer-motion": "static-1.76",
  "hs-story-utils": "static-1.9678",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5519",
  "react-virtualized": "static-2.104",
  "StyleGuideUI": "static-3.495",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2479",
  "ui-fonts": "static-1.996",
  "ui-images": "static-2.1230",
  "bend-plugin-foundations-theming": "static-1.3191",
  "foundations-theming-base": "static-1.3693",
  "stylex": "static-1.38",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3389",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4569",
  "ui-addon-video-player": "static-1.8955",
  "ai-components-ui-library": "static-1.9598",
  "ai-rendering-library": "static-1.11012",
  "chirp-fetch": "static-1.2142",
  "connections-embed-lib": "static-1.1434",
  "copilot-toolkit": "static-1.11751",
  "feedback-loader": "static-1.29739",
  "laboratory-lib": "static-3.7403",
  "marketplace-embed": "static-1.22827",
  "marketplace-ui-details": "static-1.10507",
  "marketplace-ui-reviews": "static-1.20567",
  "marketplace-ui-tracking": "static-1.14782",
  "sanitize-text": "static-1.8401",
  "usage-tracker-multi": "static-1.6021",
  "usage-tracker-session-replay": "static-1.5293",
  "wootric-nps": "static-1.7164",
  "quartz-head": "static-1.1037",
  "web-vitals": "static-1.11",
  "apollo-link-hub-http": "static-2.4908",
  "immer": "static-1.94",
  "immerable": "static-1.4402",
  "highcharts": "static-8.108",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2652",
  "reporting-data": "static-1.68604",
  "cssUtils": "static-1.871",
  "flux-actions": "static-1.360",
  "HubStyle": "static-2.12041",
  "PatternValidationJS": "static-1.3148",
  "react-colorpicker": "static-2.10459",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10617",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7597",
  "icons": "static-2.674",
  "marketplace-ui-apps-core": "static-1.19144",
  "storybook-react": "static-1.37",
  "trellis-story-utils": "static-1.4761",
  "foundations-components-test-utils": "static-1.5877",
  "quartz-i18n": "static-1.1047",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.361",
  "ads-unified-auth-lib": "static-1.1070",
  "google-sheets-integration-lib": "static-1.938",
  "microsoft-drive-auth-lib": "static-1.30",
  "surveymonkey-integration-lib": "static-1.382",
  "slack-ui-library": "static-1.10649",
  "fsm": "static-1.3990",
  "customer-data-objects": "static-1.7938",
  "property-translator": "static-1.5646",
  "hs-locale-management": "static-1.258",
  "frontend-preferences-client": "static-1.8179",
  "hs-promise-utils": "static-1.5848",
  "hubspot-apollo-client": "static-1.5130",
  "integrations-error-boundary-lib": "static-1.14349",
  "integrations-tracking-lib": "static-1.5859",
  "native-integrations-shared-strings": "static-1.8028",
  "sanitize": "static-1.4727",
  "superstore": "static-1.5008",
  "ui-shepherd-react": "static-3.10514",
  "ai-settings-ui-library": "static-1.8260",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4828",
  "immutable-less": "static-1.4902",
  "marketplace-ui-client-types": "static-1.18019",
  "nav-meta": "static-1.30358",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18323",
  "ui-product-approvals-common": "static-1.888",
  "ai-studio-lib": "static-1.12367",
  "hubspot-prosemirror": "static-1.18879",
  "integrations-reconnect-lib": "static-1.407",
  "ui-addon-iframeable": "static-1.9327",
  "ui-addon-integrations-directory-panel": "static-2.8277",
  "ui-product-approvals": "static-1.28993",
  "ui-tool-access": "static-1.10404",
  "inbound-db-properties-service-client": "static-1.4022",
  "property-management-common": "static-1.6289",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.567",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1047",
  "quartz-test": "static-1.1047",
  "quartz-tracking": "static-1.751",
  "trellis-components": "static-1.2498",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.324",
  "bender-build-tools": "static-1.3358",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22658",
  "ContentUtils": "static-1.69062",
  "customer-data-objects-ui-components": "static-1.13281",
  "sassPrefix": "static-1.161",
  "avatar-components": "static-1.2748",
  "breeze-engine-core": "static-1.857",
  "breeze-onboarding-components": "static-1.623",
  "customer-data-filters-ui": "static-1.40772",
  "customer-data-reference-ui-components": "static-1.13431",
  "embedded-academy-lib": "static-1.15375",
  "ExportDialog": "static-6.10631",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.41922",
  "reporting-snowflake": "static-1.57222",
  "reporting-ui-components": "static-2.65875",
  "reporting-visualizations": "static-1.60680",
  "trial-components-library": "static-1.14028",
  "trellis-theming": "static-1.1214",
  "ui-addon-teams": "static-1.21857",
  "upgrade-components-lib": "static-1.459",
  "magpie-lib": "static-1.5722",
  "navigation-components": "static-1.18721",
  "breeze-engine-lib": "static-1.1579",
  "magpie-types": "static-1.5182",
  "simple-logging-lib": "static-1.3301",
  "fail-safe": "static-1.206",
  "app-governance-lib": "static-1.2301",
  "developer-experience-shared-components": "static-1.10752",
  "purchase-motions-components": "static-1.6287",
  "transmute": "static-2.85",
  "usage-based-billing-components-lib": "static-1.10054",
  "usage-tracker-anonymous": "static-1.6024",
  "usage-tracker-public": "static-1.7418",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.3951",
  "reference-resolvers": "static-1.8433",
  "ui-extensibility-client-types": "static-1.4172",
  "hubspot-apollo-cache": "static-1.589",
  "universal-page-editor-lib": "static-1.3260",
  "final-form": "static-1.75",
  "redux-toolkit": "static-1.75",
  "simple-data-table": "static-1.3442",
  "atom": "static-1.5336",
  "merchandise-lib": "static-1.273",
  "salesImages": "static-1.530",
  "codemirror": "static-5.99",
  "react-codemirror": "static-1.10891",
  "ui-addon-draggable": "static-3.5007",
  "content-assistance-lib": "static-1.8136",
  "content-media-capture": "static-1.5318",
  "customer-data-ui-utilities": "static-1.10077",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24367",
  "growth-payments-core": "static-1.26081",
  "knowledge-content-types": "static-1.8620",
  "payment-link-components": "static-1.24084",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20240",
  "ui-addon-emoji-picker": "static-1.10136",
  "ui-business-units-lib": "static-1.9335",
  "video-components-external": "static-1.12068",
  "video-data-lib": "static-1.35726",
  "navigation-messaging": "static-1.8048",
  "collaboration-sidebar": "static-1.58618",
  "react-dnd-compat": "static-1.4867",
  "batch-promise": "static-1.1794",
  "crm-component-utils": "static-1.39739",
  "crm-properties-common-lib": "static-1.6141",
  "customer-data-properties": "static-1.52445",
  "external-options-client-types": "static-1.4304",
  "framework-data-schema-resolvers": "static-1.7144",
  "property-value-citations": "static-1.3060",
  "reference-resolvers-lite": "static-1.8351",
  "hubspotter-http-shared-msw-handlers": "static-1.10532",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "tanstack-virtual": "static-1.36",
  "cms-field-types": "static-1.5067",
  "content-icons-ui": "static-1.2315",
  "breeze-artifacts-sdk": "static-1.199",
  "onboarding-journeys-lib": "static-1.785",
  "pulse": "static-1.877",
  "conversations-skeleton-state": "static-1.7500",
  "crm-message-bus": "static-1.43648",
  "customer-data-filters-ui-msw-helpers": "static-1.23207",
  "events-data-lib": "static-1.493",
  "FormUrlGenerator": "static-2.4977",
  "framework-builder-read-service-client": "static-1.4185",
  "hs-resources": "static-1.442",
  "multi-account-reference-resolvers": "static-1.1247",
  "onboarding-scopes": "static-1.6707",
  "onboarding-tours": "static-1.17044",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14375",
  "academy-common-lib": "static-1.14835",
  "dashboard-lib": "static-1.82642",
  "getting-started-shared-tasks": "static-1.19122",
  "hubspot-prosemirror-plugins": "static-1.18871",
  "share-with-third-party-component-lib": "static-1.8956",
  "ui-asset-management-lib": "static-1.11347",
  "user-context": "static-1.5364",
  "reporting-plugins": "static-1.10671",
  "reporting-reports": "static-1.68282",
  "hubs-service-types": "static-1.1509",
  "purchase-motions-api": "static-1.6290",
  "signup-constants": "static-1.19506",
  "idb-keyval": "static-1.48",
  "reactive-lib": "static-1.972",
  "nest": "static-1.487",
  "breeze-engine-chat-components": "static-1.557",
  "ably": "static-2.2",
  "bend-plugin-fail-safe": "static-1.157",
  "framework-listing-lib": "static-2.29384",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31335",
  "apps-service-types": "static-1.3995",
  "oauth-service-types": "static-1.4507",
  "signup-ui-url-generator": "static-2.8310",
  "onboarding-tours-client": "static-1.5258",
  "one-click-checkout": "static-1.312",
  "platform-infra-nav-components": "static-1.7852",
  "subscription-experience-data-types": "static-1.15206",
  "crm-record-cards-service-types": "static-1.3759",
  "location-customization-utils-lib": "static-1.9997",
  "redux-thunk": "static-2.77",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "react-flip-move": "static-1.75",
  "ui-coaching-tips": "static-1.29221",
  "content-media-composition-data-lib": "static-1.13122",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4676",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.629",
  "ui-addon-opt": "static-4.8616",
  "commerce-tours-lib": "static-1.6540",
  "growth-onboarding-reliability": "static-1.5332",
  "sales-checkout-service-client": "static-1.3779",
  "data-token-picker": "static-1.16818",
  "FileManagerLib": "static-1.40007",
  "content-media-compositions": "static-2.17129",
  "media-bridge-lib": "static-1.19340",
  "chatspot-widget-iframe": "static-1.22649",
  "collaboration-sidebar-common": "static-1.3415",
  "marketing-platform-lib": "static-1.7120",
  "card-properties-lib": "static-1.44911",
  "commerce-subscription-lib": "static-1.37687",
  "crm-actions": "static-1.6603",
  "crm-cards-sdk": "static-1.44392",
  "customer-data-properties-shared-msw-handlers": "static-1.9861",
  "customer-data-tracking": "static-1.7132",
  "calling-global-api": "static-1.65384",
  "calling-internal-common": "static-1.31568",
  "calling-lifecycle-internal": "static-1.66766",
  "calling-lifecycle-messages": "static-1.59060",
  "commerce-products-lib": "static-1.10415",
  "conditional-properties-service-client": "static-1.3980",
  "crm-index-visualization-core": "static-1.4481",
  "crm-links": "static-1.6574",
  "crm-pipelines-api-client-types": "static-1.4313",
  "formula-editor": "static-1.14680",
  "google-libphonenumber": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4390",
  "meetings-icalendar-utils-lib": "static-1.887",
  "multi-currency-client-types": "static-1.3873",
  "object-builder-ui-client": "static-1.49543",
  "pipeline-validation-client-types": "static-1.4148",
  "smart-data-capture-core": "static-1.33",
  "smart-property-lib": "static-1.8175",
  "tiered-pricing": "static-1.1873",
  "topics-actions-lib": "static-1.414",
  "ui-addon-form-validation": "static-1.11238",
  "zustand": "static-1.79",
  "fdsr-migration-layer": "static-1.263",
  "framework-data-schema-quick-fetch": "static-1.7049",
  "bend-plugin-pulse": "static-1.380",
  "event-emitter": "static-1.1206",
  "fast-json-patch": "static-1.67",
  "restore-request-side-panel-lib": "static-1.1562",
  "growth-data-modal": "static-1.5823",
  "growth-onboarding-confetti": "static-1.3312",
  "growth-onboarding-next-action-utils": "static-1.2603",
  "onboarding-tours-utils": "static-1.1110",
  "ui-shepherd-tracker": "static-1.7895",
  "academy-service-client": "static-1.3941",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39866",
  "SafeStorage": "static-1.4656",
  "video-embed": "static-1.36560",
  "redux-actions": "static-3.68",
  "EmailSignatureEditor": "static-1.24921",
  "viral-links-lib": "static-1.7325",
  "nested-table": "static-1.485",
  "timezone-utils": "static-2.5499",
  "getting-started-shared-tasks-store": "static-1.18240",
  "campaign-roi-lib": "static-1.10007",
  "ui-addon-calendars": "static-2.5579",
  "customer-data-views-management": "static-1.25938",
  "framework-data-table": "static-2.12452",
  "nudge-client-utils": "static-1.3073",
  "nudge-custom-ui-functions": "static-1.1423",
  "switchboard-lib": "static-1.467",
  "access-check-ui-lib": "static-1.1493",
  "app-users-service-client": "static-1.5869",
  "app-users-service-types": "static-1.5277",
  "mini-checkout-client": "static-1.27407",
  "onboarding-utils": "static-1.5613",
  "permissions-shared-i18n-strings-fe": "static-1.2118",
  "ui-coaching-tips-shared-config": "static-1.29206",
  "checkout-sdk": "static-3.24250",
  "payment-method-components": "static-1.7098",
  "touchless-buying-components": "static-1.6118",
  "upgrade-catalog-service-types": "static-1.3736",
  "edison-service-client-types": "static-1.643",
  "growth-onboarding-feedback-components": "static-1.6835",
  "audio-components": "static-1.6278",
  "FileManagerImages": "static-1.37518",
  "video-components": "static-1.14070",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92733",
  "customer-data-sidebar": "static-2.46651",
  "enrichment-properties-lib": "static-1.17813",
  "ui-addon-draggable-compat": "static-2.4514",
  "universal-record-utils-lib": "static-1.1753",
  "commerce-billing-lib": "static-1.19998",
  "commerce-shared-components-lib": "static-1.19136",
  "commerce-tools-ui-lib": "static-1.10965",
  "crm-fe-perf": "static-1.23151",
  "calling-error-reporting": "static-1.31575",
  "shared-worker-versioning": "static-1.11292",
  "calling-usage-tracker": "static-1.6790",
  "voice-sms-access-library": "static-1.1920",
  "commerce-permissions": "static-1.1027",
  "products-iframe-lib": "static-1.8504",
  "products-ui-components-shared-msw-handlers": "static-1.10916",
  "crm-index-associations-lib": "static-1.6694",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10617",
  "sales-views-client-types": "static-1.4508",
  "bark-lib": "static-1.16757",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.578",
  "policy-lib": "static-1.7045",
  "react-tinymce": "static-1.55884",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10680",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55010",
  "tinymce-plugins": "static-1.58124",
  "tinymce-themes": "static-1.56980",
  "onboarding-data-sync-lib": "static-1.2418",
  "growth-onboarding-next-action-components": "static-1.2631",
  "user-context-client": "static-1.4759",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4784",
  "outpost": "static-1.4412",
  "draft-convert": "static-2.77",
  "draft-extend": "static-3.80",
  "draft-js": "static-5.82",
  "draft-plugins": "static-2.22089",
  "sales-email-signature-service-client": "static-1.4096",
  "ts-utils-lib": "static-1.426",
  "crm-export-dialog": "static-1.6536",
  "crm-view-components": "static-1.1007",
  "react-beautiful-dnd": "static-1.67",
  "customer-data-associations": "static-1.7581",
  "nudge-custom-function-registry": "static-1.2830",
  "nudge-renderer-utils": "static-1.3149",
  "whisper-core-api": "static-1.7238",
  "InboxConnectUtils": "static-4.15465",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46754",
  "hub-http-rxjs": "static-1.834",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4243",
  "company-details-components": "static-1.6452",
  "react-performance-metrics-lib": "static-1.806",
  "pricing-pages-ui-components": "static-1.15508",
  "quote-checkout-service-types": "static-1.3709",
  "social-insights-client-types": "static-1.22685",
  "crm_universal": "static-1.22430",
  "customer-data-email": "static-1.18456",
  "card-payment-highlight-lib": "static-1.37880",
  "card-subscription-highlight-lib": "static-1.40110",
  "commerce-contract-lib": "static-1.13163",
  "invoices-highlight-card-lib": "static-1.55560",
  "orders-highlight-card-lib": "static-1.22099",
  "products-highlight-card-lib": "static-1.18698",
  "quotes-highlight-card-lib": "static-1.72748",
  "crm-source-interpretation-lib": "static-1.5583",
  "data-agent-utils": "static-1.208",
  "crm-object-search-query-utilities": "static-1.10120",
  "utility-belt": "static-1.2782",
  "payments-enrollment-embed-lib": "static-1.23709",
  "stripe-embedded-components": "static-1.7930",
  "customer-data-rte": "static-1.33566",
  "cv-backend-services": "static-1.1590",
  "growth-onboarding-empty-states": "static-1.6197",
  "payments-post-enroll-local-storage-lib": "static-1.5357",
  "qrcode-generator": "static-1.73",
  "quotes-client-types": "static-1.38838",
  "calling-orchestration-schema": "static-1.36697",
  "react-reducer-toolkit": "static-1.16274",
  "hub-http-contrib": "static-1.3291",
  "interframe": "static-3.5008",
  "tinymce-data": "static-1.41095",
  "ui-addon-sales-email": "static-1.5466",
  "layout-dnd-components": "static-1.12895",
  "layout-dnd-utils": "static-1.11870",
  "ui-brand-identity-lib": "static-1.16232",
  "NamespacedHubStyle": "static-2.9227",
  "meetings-connect-utils-lib": "static-1.7860",
  "access-control-lib": "static-1.10688",
  "EmailComponents": "static-1.55462",
  "EmailData": "static-1.54140",
  "redux-less": "static-2.9730",
  "company-details-service-types": "static-1.4190",
  "segments-query-core": "static-1.1675",
  "pricing-pages-api": "static-1.15373",
  "sequences-lib": "static-1.8469",
  "ui-gdpr-components": "static-1.10607",
  "products-ui-components": "static-1.40933",
  "accounting-integrations-ui-components": "static-1.7470",
  "invoices-ui-lib": "static-1.55576",
  "commerce-products-api": "static-1.2641",
  "invoices-iframe-lib": "static-1.57634",
  "quotes-modal-lib": "static-1.103426",
  "quotes-ui-lib": "static-1.81469",
  "stripe-connect-js": "static-1.74",
  "draft-content-plugins": "static-1.28829",
  "ContentData": "static-1.69137",
  "layout-data-lib": "static-1.10195",
  "ContentComponents": "static-2.72018",
  "marketing-contacts-lib": "static-1.10905",
  "marketing-email-service-types": "static-1.2065",
  "messaging-editing-lib": "static-1.47040",
  "messaging-usage-based-billing-components-lib": "static-1.1902",
  "automation-ui-source-apps": "static-1.19570",
  "automation-ui-types": "static-1.20488",
  "messaging-types-lib": "static-1.46777",
  "onboarding-settings-client": "static-1.4761",
  "sequences-client-types-lib": "static-1.8326",
  "commerce-tax-lib": "static-1.791",
  "price-books-api": "static-1.1640",
  "price-books-components": "static-1.1698",
  "property-description-translator": "static-1.4090",
  "ramp-editor": "static-1.807",
  "commerce-analytics-service-client": "static-1.3767",
  "totals-ui-components": "static-1.24213",
  "SalesContentIndexUI": "static-3.9572",
  "advanced-menus-core": "static-1.15513",
  "advanced-menus-lib": "static-1.12394",
  "ui-memberships-settings-lib": "static-1.34741",
  "automation-ui-ubb": "static-1.6404",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7588",
  "data-token-views": "static-1.16799",
  "forms-utils-lib": "static-1.13024",
  "payments-embed-points-lib": "static-1.13515",
  "simple-menus-core": "static-1.15512",
  "simple-menus-lib": "static-1.17029",
  "videoconference-integration-components": "static-1.7180",
  "marketing-contacts-client": "static-1.7760",
  "mc-hard-limits-client-types": "static-1.154",
  "automation-applications-service-types": "static-1.3648",
  "automation-platform-service-types": "static-1.2659",
  "ContentEditorUI": "static-2.77809",
  "short-messages-app-service-client": "static-1.4169",
  "web-interactives-components": "static-1.14179",
  "web-interactives-data": "static-1.14180",
  "messaging-shared-utils-lib": "static-1.1351",
  "messaging-user-info-utils-lib": "static-1.1521",
  "email-portal-health-service-types": "static-1.1229",
  "line-items-api": "static-1.1039",
  "commerce-totals-service-types": "static-1.3996",
  "FireAlarmUi": "static-1.4685",
  "sales-templates-service-types-lib": "static-1.4348",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22424",
  "automation-ui-usage-tracking": "static-1.21887",
  "data-studio-ubb": "static-1.3419",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27572",
  "content-management-data-lib": "static-1.5879",
  "copilot-plugins": "static-1.11723",
  "cta-picker": "static-1.37001",
  "customer-agent-discovery-components-lib": "static-1.3789",
  "editor-components": "static-1.13582",
  "editor-iframe-lib": "static-1.8737",
  "error-messaging-js": "static-1.5447",
  "FormsCommonComponents": "static-1.86478",
  "pictos": "static-7.189",
  "react-transition-group": "static-2.69",
  "redux-request-state": "static-1.10900",
  "SharedLegalStrings": "static-1.1997",
  "smart-content-core": "static-1.43085",
  "smart-content-lib": "static-1.43738",
  "social-composer-lib": "static-1.60097",
  "structured-content-lib": "static-1.25829",
  "theme-previewer-lib": "static-1.53858",
  "tinymce-copilot": "static-1.17078",
  "xray-recommendation-lib": "static-1.8211",
  "automation-ui-routing": "static-1.21845",
  "sql-reporting-client-types": "static-1.5852",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42706",
  "campaigns-utils-lib": "static-1.3453",
  "reporting-enablement": "static-1.23727",
  "forms-ai-lib": "static-1.4693",
  "codemirror-dlb": "static-1.59368",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6690",
  "report-customization-components": "static-1.13812",
  "data-quality-ui-library": "static-1.13688",
  "reporting-filters": "static-1.921",
  "reporting-insights-lib": "static-1.2473"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13129",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.491",
  "data-fetching-client": "/data-fetching-client/static-1.9908",
  "foundations-components": "/foundations-components/static-1.8394",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1419",
  "foundations-theming": "/foundations-theming/static-1.4708",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.86",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8278",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10534",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11734",
  "I18n": "/I18n/static-7.1663",
  "jasmine-runner": "/jasmine-runner/static-1.6700",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.556",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13192",
  "quartz": "/quartz/static-1.7372",
  "react-dlb": "/react-dlb/static-1.85",
  "react-rhumb": "/react-rhumb/static-1.16961",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3106",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10537",
  "reselect": "/reselect/static-3.9",
  "settings-ui-lib": "/settings-ui-lib/static-1.12772",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7563",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11396",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9788",
  "unified-auth": "/unified-auth/static-1.813",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1095",
  "usage-tracker": "/usage-tracker/static-1.7607",
  "usage-tracker-core": "/usage-tracker-core/static-1.7457",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8350",
  "hub-http": "/hub-http/static-1.6465",
  "integrations-lib": "/integrations-lib/static-1.16934",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20612",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.598",
  "property-management-iframe": "/property-management-iframe/static-1.14001",
  "quartz-config": "/quartz-config/static-1.1150",
  "quartz-core": "/quartz-core/static-1.6591",
  "quartz-routing": "/quartz-routing/static-1.802",
  "quick-fetch": "/quick-fetch/static-1.4097",
  "react": "/react/static-7.191",
  "rpc-client-utils": "/rpc-client-utils/static-1.4914",
  "ts-schema": "/ts-schema/static-1.4259",
  "ui-universal-auth": "/ui-universal-auth/static-1.9299",
  "UIComponents": "/UIComponents/static-3.8680",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9867",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3582",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3649",
  "quartz-webpack": "/quartz-webpack/static-1.3596",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.450",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4663",
  "floating-ui": "/floating-ui/static-1.62",
  "foundations-assets": "/foundations-assets/static-1.5129",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2424",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-story-utils": "/hs-story-utils/static-1.9678",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5519",
  "react-virtualized": "/react-virtualized/static-2.104",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2479",
  "ui-fonts": "/ui-fonts/static-1.996",
  "ui-images": "/ui-images/static-2.1230",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3191",
  "foundations-theming-base": "/foundations-theming-base/static-1.3693",
  "stylex": "/stylex/static-1.38",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3389",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4569",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8955",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9598",
  "ai-rendering-library": "/ai-rendering-library/static-1.11012",
  "chirp-fetch": "/chirp-fetch/static-1.2142",
  "connections-embed-lib": "/connections-embed-lib/static-1.1434",
  "copilot-toolkit": "/copilot-toolkit/static-1.11751",
  "feedback-loader": "/feedback-loader/static-1.29739",
  "laboratory-lib": "/laboratory-lib/static-3.7403",
  "marketplace-embed": "/marketplace-embed/static-1.22827",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10507",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20567",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.14782",
  "sanitize-text": "/sanitize-text/static-1.8401",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6021",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5293",
  "wootric-nps": "/wootric-nps/static-1.7164",
  "quartz-head": "/quartz-head/static-1.1037",
  "web-vitals": "/web-vitals/static-1.11",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4908",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4402",
  "highcharts": "/highcharts/static-8.108",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2652",
  "reporting-data": "/reporting-data/static-1.68604",
  "cssUtils": "/cssUtils/static-1.871",
  "flux-actions": "/flux-actions/static-1.360",
  "HubStyle": "/HubStyle/static-2.12041",
  "PatternValidationJS": "/PatternValidationJS/static-1.3148",
  "react-colorpicker": "/react-colorpicker/static-2.10459",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10617",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7597",
  "icons": "/icons/static-2.674",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19144",
  "storybook-react": "/storybook-react/static-1.37",
  "trellis-story-utils": "/trellis-story-utils/static-1.4761",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5877",
  "quartz-i18n": "/quartz-i18n/static-1.1047",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.361",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1070",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.938",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.30",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.382",
  "slack-ui-library": "/slack-ui-library/static-1.10649",
  "fsm": "/fsm/static-1.3990",
  "customer-data-objects": "/customer-data-objects/static-1.7938",
  "property-translator": "/property-translator/static-1.5646",
  "hs-locale-management": "/hs-locale-management/static-1.258",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8179",
  "hs-promise-utils": "/hs-promise-utils/static-1.5848",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5130",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14349",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5859",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8028",
  "sanitize": "/sanitize/static-1.4727",
  "superstore": "/superstore/static-1.5008",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10514",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8260",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4828",
  "immutable-less": "/immutable-less/static-1.4902",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18019",
  "nav-meta": "/nav-meta/static-1.30358",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18323",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.888",
  "ai-studio-lib": "/ai-studio-lib/static-1.12367",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18879",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.407",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9327",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8277",
  "ui-product-approvals": "/ui-product-approvals/static-1.28993",
  "ui-tool-access": "/ui-tool-access/static-1.10404",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4022",
  "property-management-common": "/property-management-common/static-1.6289",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.567",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1047",
  "quartz-test": "/quartz-test/static-1.1047",
  "quartz-tracking": "/quartz-tracking/static-1.751",
  "trellis-components": "/trellis-components/static-1.2498",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.324",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22658",
  "ContentUtils": "/ContentUtils/static-1.69062",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13281",
  "sassPrefix": "/sassPrefix/static-1.161",
  "avatar-components": "/avatar-components/static-1.2748",
  "breeze-engine-core": "/breeze-engine-core/static-1.857",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.623",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40772",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13431",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15375",
  "ExportDialog": "/ExportDialog/static-6.10631",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.41922",
  "reporting-snowflake": "/reporting-snowflake/static-1.57222",
  "reporting-ui-components": "/reporting-ui-components/static-2.65875",
  "reporting-visualizations": "/reporting-visualizations/static-1.60680",
  "trial-components-library": "/trial-components-library/static-1.14028",
  "trellis-theming": "/trellis-theming/static-1.1214",
  "ui-addon-teams": "/ui-addon-teams/static-1.21857",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.459",
  "magpie-lib": "/magpie-lib/static-1.5722",
  "navigation-components": "/navigation-components/static-1.18721",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1579",
  "magpie-types": "/magpie-types/static-1.5182",
  "simple-logging-lib": "/simple-logging-lib/static-1.3301",
  "fail-safe": "/fail-safe/static-1.206",
  "app-governance-lib": "/app-governance-lib/static-1.2301",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10752",
  "purchase-motions-components": "/purchase-motions-components/static-1.6287",
  "transmute": "/transmute/static-2.85",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10054",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6024",
  "usage-tracker-public": "/usage-tracker-public/static-1.7418",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.3951",
  "reference-resolvers": "/reference-resolvers/static-1.8433",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4172",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.589",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3260",
  "final-form": "/final-form/static-1.75",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "simple-data-table": "/simple-data-table/static-1.3442",
  "atom": "/atom/static-1.5336",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "salesImages": "/salesImages/static-1.530",
  "codemirror": "/codemirror/static-5.99",
  "react-codemirror": "/react-codemirror/static-1.10891",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5007",
  "content-assistance-lib": "/content-assistance-lib/static-1.8136",
  "content-media-capture": "/content-media-capture/static-1.5318",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10077",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24367",
  "growth-payments-core": "/growth-payments-core/static-1.26081",
  "knowledge-content-types": "/knowledge-content-types/static-1.8620",
  "payment-link-components": "/payment-link-components/static-1.24084",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20240",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10136",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9335",
  "video-components-external": "/video-components-external/static-1.12068",
  "video-data-lib": "/video-data-lib/static-1.35726",
  "navigation-messaging": "/navigation-messaging/static-1.8048",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58618",
  "react-dnd-compat": "/react-dnd-compat/static-1.4867",
  "batch-promise": "/batch-promise/static-1.1794",
  "crm-component-utils": "/crm-component-utils/static-1.39739",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6141",
  "customer-data-properties": "/customer-data-properties/static-1.52445",
  "external-options-client-types": "/external-options-client-types/static-1.4304",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7144",
  "property-value-citations": "/property-value-citations/static-1.3060",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8351",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10532",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "cms-field-types": "/cms-field-types/static-1.5067",
  "content-icons-ui": "/content-icons-ui/static-1.2315",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.199",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.785",
  "pulse": "/pulse/static-1.877",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7500",
  "crm-message-bus": "/crm-message-bus/static-1.43648",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23207",
  "events-data-lib": "/events-data-lib/static-1.493",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4977",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4185",
  "hs-resources": "/hs-resources/static-1.442",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1247",
  "onboarding-scopes": "/onboarding-scopes/static-1.6707",
  "onboarding-tours": "/onboarding-tours/static-1.17044",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14375",
  "academy-common-lib": "/academy-common-lib/static-1.14835",
  "dashboard-lib": "/dashboard-lib/static-1.82642",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19122",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18871",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8956",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11347",
  "user-context": "/user-context/static-1.5364",
  "reporting-plugins": "/reporting-plugins/static-1.10671",
  "reporting-reports": "/reporting-reports/static-1.68282",
  "hubs-service-types": "/hubs-service-types/static-1.1509",
  "purchase-motions-api": "/purchase-motions-api/static-1.6290",
  "signup-constants": "/signup-constants/static-1.19506",
  "idb-keyval": "/idb-keyval/static-1.48",
  "reactive-lib": "/reactive-lib/static-1.972",
  "nest": "/nest/static-1.487",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.557",
  "ably": "/ably/static-2.2",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.157",
  "framework-listing-lib": "/framework-listing-lib/static-2.29384",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31335",
  "apps-service-types": "/apps-service-types/static-1.3995",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8310",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5258",
  "one-click-checkout": "/one-click-checkout/static-1.312",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7852",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15206",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9997",
  "redux-thunk": "/redux-thunk/static-2.77",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "react-flip-move": "/react-flip-move/static-1.75",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29221",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13122",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4676",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.629",
  "ui-addon-opt": "/ui-addon-opt/static-4.8616",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6540",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5332",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3779",
  "data-token-picker": "/data-token-picker/static-1.16818",
  "FileManagerLib": "/FileManagerLib/static-1.40007",
  "content-media-compositions": "/content-media-compositions/static-2.17129",
  "media-bridge-lib": "/media-bridge-lib/static-1.19340",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22649",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3415",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7120",
  "card-properties-lib": "/card-properties-lib/static-1.44911",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37687",
  "crm-actions": "/crm-actions/static-1.6603",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44392",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9861",
  "customer-data-tracking": "/customer-data-tracking/static-1.7132",
  "calling-global-api": "/calling-global-api/static-1.65384",
  "calling-internal-common": "/calling-internal-common/static-1.31568",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66766",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59060",
  "commerce-products-lib": "/commerce-products-lib/static-1.10415",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3980",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4481",
  "crm-links": "/crm-links/static-1.6574",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4313",
  "formula-editor": "/formula-editor/static-1.14680",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4390",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.887",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3873",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49543",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4148",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.33",
  "smart-property-lib": "/smart-property-lib/static-1.8175",
  "tiered-pricing": "/tiered-pricing/static-1.1873",
  "topics-actions-lib": "/topics-actions-lib/static-1.414",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11238",
  "zustand": "/zustand/static-1.79",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.263",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7049",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.380",
  "event-emitter": "/event-emitter/static-1.1206",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1562",
  "growth-data-modal": "/growth-data-modal/static-1.5823",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3312",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2603",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1110",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7895",
  "academy-service-client": "/academy-service-client/static-1.3941",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39866",
  "SafeStorage": "/SafeStorage/static-1.4656",
  "video-embed": "/video-embed/static-1.36560",
  "redux-actions": "/redux-actions/static-3.68",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24921",
  "viral-links-lib": "/viral-links-lib/static-1.7325",
  "nested-table": "/nested-table/static-1.485",
  "timezone-utils": "/timezone-utils/static-2.5499",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18240",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10007",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5579",
  "customer-data-views-management": "/customer-data-views-management/static-1.25938",
  "framework-data-table": "/framework-data-table/static-2.12452",
  "nudge-client-utils": "/nudge-client-utils/static-1.3073",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1423",
  "switchboard-lib": "/switchboard-lib/static-1.467",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1493",
  "app-users-service-client": "/app-users-service-client/static-1.5869",
  "app-users-service-types": "/app-users-service-types/static-1.5277",
  "mini-checkout-client": "/mini-checkout-client/static-1.27407",
  "onboarding-utils": "/onboarding-utils/static-1.5613",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2118",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29206",
  "checkout-sdk": "/checkout-sdk/static-3.24250",
  "payment-method-components": "/payment-method-components/static-1.7098",
  "touchless-buying-components": "/touchless-buying-components/static-1.6118",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3736",
  "edison-service-client-types": "/edison-service-client-types/static-1.643",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6835",
  "audio-components": "/audio-components/static-1.6278",
  "FileManagerImages": "/FileManagerImages/static-1.37518",
  "video-components": "/video-components/static-1.14070",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92733",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46651",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17813",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4514",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1753",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19998",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19136",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10965",
  "crm-fe-perf": "/crm-fe-perf/static-1.23151",
  "calling-error-reporting": "/calling-error-reporting/static-1.31575",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11292",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6790",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1920",
  "commerce-permissions": "/commerce-permissions/static-1.1027",
  "products-iframe-lib": "/products-iframe-lib/static-1.8504",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10916",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6694",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10617",
  "sales-views-client-types": "/sales-views-client-types/static-1.4508",
  "bark-lib": "/bark-lib/static-1.16757",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.578",
  "policy-lib": "/policy-lib/static-1.7045",
  "react-tinymce": "/react-tinymce/static-1.55884",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10680",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55010",
  "tinymce-plugins": "/tinymce-plugins/static-1.58124",
  "tinymce-themes": "/tinymce-themes/static-1.56980",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2418",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2631",
  "user-context-client": "/user-context-client/static-1.4759",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4784",
  "outpost": "/outpost/static-1.4412",
  "draft-convert": "/draft-convert/static-2.77",
  "draft-extend": "/draft-extend/static-3.80",
  "draft-js": "/draft-js/static-5.82",
  "draft-plugins": "/draft-plugins/static-2.22089",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4096",
  "ts-utils-lib": "/ts-utils-lib/static-1.426",
  "crm-export-dialog": "/crm-export-dialog/static-1.6536",
  "crm-view-components": "/crm-view-components/static-1.1007",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.67",
  "customer-data-associations": "/customer-data-associations/static-1.7581",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2830",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3149",
  "whisper-core-api": "/whisper-core-api/static-1.7238",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15465",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46754",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.834",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4243",
  "company-details-components": "/company-details-components/static-1.6452",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.806",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15508",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3709",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "crm_universal": "/crm_universal/static-1.22430",
  "customer-data-email": "/customer-data-email/static-1.18456",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37880",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40110",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13163",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55560",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22099",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18698",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72748",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5583",
  "data-agent-utils": "/data-agent-utils/static-1.208",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10120",
  "utility-belt": "/utility-belt/static-1.2782",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23709",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7930",
  "customer-data-rte": "/customer-data-rte/static-1.33566",
  "cv-backend-services": "/cv-backend-services/static-1.1590",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6197",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5357",
  "qrcode-generator": "/qrcode-generator/static-1.73",
  "quotes-client-types": "/quotes-client-types/static-1.38838",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36697",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16274",
  "hub-http-contrib": "/hub-http-contrib/static-1.3291",
  "interframe": "/interframe/static-3.5008",
  "tinymce-data": "/tinymce-data/static-1.41095",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5466",
  "layout-dnd-components": "/layout-dnd-components/static-1.12895",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11870",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16232",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9227",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7860",
  "access-control-lib": "/access-control-lib/static-1.10688",
  "EmailComponents": "/EmailComponents/static-1.55462",
  "EmailData": "/EmailData/static-1.54140",
  "redux-less": "/redux-less/static-2.9730",
  "company-details-service-types": "/company-details-service-types/static-1.4190",
  "segments-query-core": "/segments-query-core/static-1.1675",
  "pricing-pages-api": "/pricing-pages-api/static-1.15373",
  "sequences-lib": "/sequences-lib/static-1.8469",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10607",
  "products-ui-components": "/products-ui-components/static-1.40933",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7470",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55576",
  "commerce-products-api": "/commerce-products-api/static-1.2641",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57634",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103426",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81469",
  "stripe-connect-js": "/stripe-connect-js/static-1.74",
  "draft-content-plugins": "/draft-content-plugins/static-1.28829",
  "ContentData": "/ContentData/static-1.69137",
  "layout-data-lib": "/layout-data-lib/static-1.10195",
  "ContentComponents": "/ContentComponents/static-2.72018",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10905",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2065",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47040",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1902",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19570",
  "automation-ui-types": "/automation-ui-types/static-1.20488",
  "messaging-types-lib": "/messaging-types-lib/static-1.46777",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4761",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8326",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.791",
  "price-books-api": "/price-books-api/static-1.1640",
  "price-books-components": "/price-books-components/static-1.1698",
  "property-description-translator": "/property-description-translator/static-1.4090",
  "ramp-editor": "/ramp-editor/static-1.807",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3767",
  "totals-ui-components": "/totals-ui-components/static-1.24213",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9572",
  "advanced-menus-core": "/advanced-menus-core/static-1.15513",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12394",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34741",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6404",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7588",
  "data-token-views": "/data-token-views/static-1.16799",
  "forms-utils-lib": "/forms-utils-lib/static-1.13024",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13515",
  "simple-menus-core": "/simple-menus-core/static-1.15512",
  "simple-menus-lib": "/simple-menus-lib/static-1.17029",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7180",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7760",
  "mc-hard-limits-client-types": "/mc-hard-limits-client-types/static-1.154",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3648",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2659",
  "ContentEditorUI": "/ContentEditorUI/static-2.77809",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4169",
  "web-interactives-components": "/web-interactives-components/static-1.14179",
  "web-interactives-data": "/web-interactives-data/static-1.14180",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1351",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1521",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1229",
  "line-items-api": "/line-items-api/static-1.1039",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3996",
  "FireAlarmUi": "/FireAlarmUi/static-1.4685",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4348",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22424",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21887",
  "data-studio-ubb": "/data-studio-ubb/static-1.3419",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27572",
  "content-management-data-lib": "/content-management-data-lib/static-1.5879",
  "copilot-plugins": "/copilot-plugins/static-1.11723",
  "cta-picker": "/cta-picker/static-1.37001",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3789",
  "editor-components": "/editor-components/static-1.13582",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8737",
  "error-messaging-js": "/error-messaging-js/static-1.5447",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86478",
  "pictos": "/pictos/static-7.189",
  "react-transition-group": "/react-transition-group/static-2.69",
  "redux-request-state": "/redux-request-state/static-1.10900",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1997",
  "smart-content-core": "/smart-content-core/static-1.43085",
  "smart-content-lib": "/smart-content-lib/static-1.43738",
  "social-composer-lib": "/social-composer-lib/static-1.60097",
  "structured-content-lib": "/structured-content-lib/static-1.25829",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53858",
  "tinymce-copilot": "/tinymce-copilot/static-1.17078",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8211",
  "automation-ui-routing": "/automation-ui-routing/static-1.21845",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5852",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42706",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3453",
  "reporting-enablement": "/reporting-enablement/static-1.23727",
  "forms-ai-lib": "/forms-ai-lib/static-1.4693",
  "codemirror-dlb": "/codemirror-dlb/static-1.59368",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6690",
  "report-customization-components": "/report-customization-components/static-1.13812",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13688",
  "reporting-filters": "/reporting-filters/static-1.921",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2473"
}
};
